import { useState, useEffect } from "react";
import { Button, InputGroup, Form } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import VendorsList from "./VendorsList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import AddProfileModal from "./AddProfileModal";

import { useNavigate, useLocation } from "react-router-dom";

function VendorsMain() {
  const axiosPrivate = useAxiosPrivate();
  const [vendors, getVendors] = useState("");
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState("");
  const navigate = useNavigate;
  const location = useLocation;

  const getAllVendors = async () => {
    let isMounted = true;
    const controller = new AbortController();
    try {
      const response = await axiosPrivate.get("vendors", {
        signal: controller.signal,
      });

      const initialVendors = response.data.map(v => ({ ...v, warning_status: 'loading' }));
      isMounted && getVendors(initialVendors);

      axiosPrivate.get(`vendors/status`, {
        signal: controller.signal,
      }).then(responseHealth => {
        if (responseHealth.data && isMounted) {
          const statuses = responseHealth.data;
          getVendors(prevVendors => {
            if (!Array.isArray(prevVendors)) return prevVendors;
            return prevVendors.map((vendor) => {
              const statusObj = statuses.find(s => s.vendor_id === vendor.id);
              return {
                ...vendor,
                warning_status: statusObj ? statusObj.warning_status : false
              };
            });
          });
        }
      }).catch(err => {
        console.error("Health fetch failed", err);
        if (isMounted) {
          getVendors(prevVendors => {
            if (!Array.isArray(prevVendors)) return prevVendors;
            return prevVendors.map((vendor) => ({ ...vendor, warning_status: false }));
          });
        }
      });

    } catch (err) {
      console.error(err);
      navigate("/login", { state: { from: location }, replace: true });
    }
  };


  useEffect(() => {
    getAllVendors();

  }, []);

  const onVendorClose = () => {
    setIsCompanyOpen(false);
    getAllVendors();
  };

  return (
    <div>
      <div class="prcContentWrap">
        <div className="container prcVendorDashWrap">
          <div className="row">
            <div className="col-md-12">
              <div className="row mb-2 prcVendorDashAdd">
                <div className="col-sm-4">
                  <h2>Seznam podjetij</h2>
                </div>
                <div className="col-sm-4">
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Išči..."
                      aria-label="Išči"
                      onChange={(e) => setSearchPhrase(e.target.value)}
                    />
                    <InputGroup.Text id="basic-addon2">
                      {<FontAwesomeIcon icon={faMagnifyingGlass} />}
                    </InputGroup.Text>
                  </InputGroup>
                </div>
                <div className="col-sm-4 text-md-end">
                  <Button
                    color="primary"
                    onClick={() => setIsCompanyOpen(true)}
                  >
                    Dodaj podjetje
                  </Button>
                </div>
              </div>
              <div className="row prcVendorDashTableHeader">
                <div className="col-md-1 prcSortHeader">
                  <span className="hideDesktop">Sortiraj</span>
                  <span className="hideMobile">#</span>
                </div>
                <div className="col-md-3 prcSortElement">
                  <span>Podjetje</span>
                </div>
                <div className="col-md-1 prcSortElement">
                  <span>Jeziki</span>
                </div>
                <div className="col-md-1 prcSortElement">
                  <span>url</span>
                </div>
                <div className="col-md-1 prcSortElement prcSortElementSelect">
                  <select>
                    <option value="all">Naročnina</option>
                    <option value="BASIC">BASIC</option>
                    <option value="TRIAL">TRIAL</option>
                    <option value="INACTIVE">INACTIVE</option>
                    <option value="DISABLED">DISABLED</option>
                  </select>
                </div>
                <div className="col-md-2 prcSortElement">
                  <span>STORITVE</span>
                </div>
                <div className="col-md-1 prcSortElement">
                  <span>Datum</span>
                </div>
                <div className="col-md-2 text-right  prcSortElement">
                  <span className="text-right">STANJE</span>
                </div>
              </div>

              {vendors.length > 0 &&
                vendors
                  .filter((vendor) => {
                    return searchPhrase.toLowerCase === ""
                      ? vendor
                      : vendor.name.toLowerCase().includes(searchPhrase);
                  })
                  .map((vendor, index) => (
                    <VendorsList key={vendor.id + index} vendor={vendor} />
                  ))}

              {vendors.length === 0 && (
                <div className="row prcVendorDashNoResults">
                  <div className="col-md-12 text-center">
                    <h2>Nobeno podjetje ne ustreza iskalnim pogojem ...</h2>
                  </div>
                </div>
              )}
              <AddProfileModal
                open={isCompanyOpen}
                onClose={() => onVendorClose()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VendorsMain;
